// eslint-disable-next-line
import React from 'react';

import '../css/listSelect.css'

import Container from '../basicComponents/Container';
import TextClick from '../basicComponents/TextClick';
import Icon from '../basicComponents/Icon';

interface ListEntry {
    text: string;
    selected: boolean;
}

export interface ListSelectProps {
    allEntries: string[];
    selectedEntries: string[];
    handleSelectChange: (selectedEntries: string[]) => void;
}

export interface ListSelectState {
    leftEntries: ListEntry[];
    rightEntries: ListEntry[];
}

export default class ListSelect extends React.Component<ListSelectProps, ListSelectState> {

    constructor(props: ListSelectProps) {

        // call constructor
        super(props);

        // split entries in left and right entries
        const leftEntries: ListEntry[] = [];
        const rightEntries: ListEntry[] = [];

        this.props.allEntries.forEach( entry => {
            if (this.props.selectedEntries.includes(entry)) {
                rightEntries.push( { text: entry, selected: false } ); 
            }
            else {
                leftEntries.push( { text: entry, selected: false } ); 
            }
        })

        // set state
        this.state = { leftEntries, rightEntries };

    }

    public render(): JSX.Element {

        return (
            <Container className='listSelect'>
                <Container className='listSelect-list'>
                    {this.state.leftEntries.map((entry, idx) => {
                        return (
                            <TextClick className={entry.selected ? 'listSelect-entry-selected' : 'listSelect-entry'} key={idx} name={'L' + idx} onClick={this.handleClick}>{entry.text}</TextClick>
                        );
                    })}
                </Container>
                <Container className='listSelect-buttons'>
                    <Icon className='listSelect-button' url={`${process.env.PUBLIC_URL}/image/16x16/arrow-right-double.png`} name='addAll' onClick={this.handleButtonClick} />
                    <Icon className='listSelect-button' url={`${process.env.PUBLIC_URL}/image/16x16/arrow-right.png`} name='add' onClick={this.handleButtonClick} />
                    <Icon className='listSelect-button' url={`${process.env.PUBLIC_URL}/image/16x16/arrow-left.png`} name='remove' onClick={this.handleButtonClick} />
                    <Icon className='listSelect-button' url={`${process.env.PUBLIC_URL}/image/16x16/arrow-left-double.png`} name='removeAll' onClick={this.handleButtonClick} />
                </Container>
                <Container className='listSelect-list'>
                    {this.state.rightEntries.map((entry, idx) => {
                        return (
                            <TextClick className={entry.selected ? 'listSelect-entry-selected' : 'listSelect-entry'} key={idx} name={'R' + idx} onClick={this.handleClick}>{entry.text}</TextClick>
                        );
                    })}
                </Container>
            </Container>
        );

    }

    public componentDidUpdate(prevProps: ListSelectProps): void {

        if (prevProps !== this.props) {

            // split entries in left and right entries
            const leftEntries: ListEntry[] = [];
            const rightEntries: ListEntry[] = [];

            this.props.allEntries.forEach( entry => {
                if (this.props.selectedEntries.includes(entry)) {
                    rightEntries.push( { text: entry, selected: false } ); 
                }
                else {
                    leftEntries.push( { text: entry, selected: false } ); 
                }
            })

            // set state
            this.setState({ leftEntries, rightEntries });

        }

    }

    private handleClick = (event: React.MouseEvent<HTMLSpanElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        if (name) {
            const idx = Number.parseInt(name.substring(1));
            if (name.startsWith('L')) {
                const newEntries: ListEntry[] = [ ...this.state.leftEntries ];
                newEntries[idx].selected = !newEntries[idx].selected;
                this.setState({ leftEntries: newEntries });
            }
            else {
                const newEntries: ListEntry[] = [ ...this.state.rightEntries ];
                newEntries[idx].selected = !newEntries[idx].selected;
                this.setState({ rightEntries: newEntries });
            }
        }

    }

    private handleButtonClick = (event: React.MouseEvent<HTMLSpanElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        switch (name) {

            case 'addAll': 
                // all entries are selected
                this.props.handleSelectChange(this.props.allEntries);
                break;

            case 'add':
                {
                    // all right side entries and all left side entries, which are highlighted, are selected
                    const newSelecteEntries = [ ...this.state.rightEntries];
                    this.state.leftEntries
                        .filter( entry => entry.selected )
                        .forEach( entry => newSelecteEntries.push( entry ) );

                    this.props.handleSelectChange(newSelecteEntries.map( entry => entry.text ));
                        
                }
                break;

            case 'remove':
                // all entries of the right side, which are not highlighted, are selected
                this.props.handleSelectChange(
                    this.state.rightEntries
                        .filter( entry => !entry.selected )
                        .map( entry => entry.text )
                );
                break;

            case 'removeAll':
                // no entry is selected
                this.props.handleSelectChange([]);
                break;

        }

    }

}
